import React from 'react';
import { Card, Row, Col, Statistic, Progress, Tag, Typography } from 'antd';
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  ProjectOutlined,
  TrophyOutlined
} from '@ant-design/icons';

const { Text } = Typography;

const StatisticsCards = ({ todoStats, projects, workload, todos }) => {
  const workloadProgress = (workload.thisWeek / workload.target) * 100;

  return (
    <Row gutter={[16, 16]} className="mb-6">
      <Col xs={24} sm={12} lg={6}>
        <Card>
          <Statistic
            title="待办事项"
            value={todoStats.total}
            prefix={<CheckCircleOutlined />}
            suffix={`/ ${todos.length}`}
            valueStyle={{ color: '#1890ff' }}
          />
          <div className="mt-2">
            <Tag color="red">高优先级 {todoStats.high}</Tag>
            <Tag color="orange">中优先级 {todoStats.medium}</Tag>
          </div>
        </Card>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <Card>
          <Statistic
            title="负责项目"
            value={projects.owned}
            prefix={<ProjectOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
          <Text type="secondary">参与项目 {projects.participated} 个</Text>
        </Card>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <Card>
          <Statistic
            title="本周工作量"
            value={workload.thisWeek}
            suffix="/ 40h"
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: workloadProgress >= 100 ? '#52c41a' : '#1890ff' }}
          />
          <Progress 
            percent={Math.round(workloadProgress)} 
            size="small" 
            className="mt-2"
            strokeColor={workloadProgress >= 100 ? '#52c41a' : '#1890ff'}
          />
        </Card>
      </Col>
      <Col xs={24} sm={12} lg={6}>
        <Card>
          <Statistic
            title="已完成项目"
            value={projects.completed}
            prefix={<TrophyOutlined />}
            valueStyle={{ color: '#faad14' }}
          />
          <Text type="secondary">累计贡献</Text>
        </Card>
      </Col>
    </Row>
  );
};

export default StatisticsCards;